import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/Index'
import Checkout from '@/components/Checkout'
import Viewcart from '@/components/Viewcart'

Vue.use(Router)

export default new Router({
  mode: 'history',

  routes: [
    {
      path: '/',
      name: 'Home',
      component: Index
    },
    {
      path: '/checkout',
      name: 'Checkout',
      component: Checkout
    },
	{
      path: '/viewcart',
      name: 'Viewcart',
      component: Viewcart
    },
    {
      path: '/:categorySlug/:itemSlug?',
      name: 'Category',
      component: Index
    }
  ],
  scrollBehavior (to, from, savedPosition) {
      if (savedPosition) {
        return savedPosition
      }

      if (to.hash) {
        return { selector: to.hash }
      }

      const toParams = (to && to.params) ? to.params : {}
      const fromParams = (from && from.params) ? from.params : {}
      const categorySlug = toParams.categorySlug
      const navigatingToItem = Boolean(toParams.itemSlug)
      const navigatingFromItem = Boolean(fromParams.itemSlug)
      const sameCategory = categorySlug && (fromParams.categorySlug === categorySlug)

      if (!categorySlug) {
        return { x: 0, y: 0 }
      }

      if (navigatingToItem) {
        return false
      }

      if (navigatingFromItem && sameCategory && !navigatingToItem) {
        return false
      }

      const selector = `#${categorySlug}`

      if (typeof document !== 'undefined' && !document.querySelector(selector)) {
        return { x: 0, y: 0 }
      }

      return { selector }
  },
})



// WEBPACK FOOTER //
// ./src/router/index.js